import * as service from './service'
export default {
  namespace: 'customerServiceAppealReason',
  state: {
    demoData: {}
  },
  effects: {
    * queryCsPunish ({ payload }, { call, put }) {
      const res = yield call(service.queryCsPunish, payload)
      return res.data.data
    },
    * submitAppeal ({ payload }, { call, put }) {
      const res = yield call(service.submitAppeal, payload)
      return res
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
